"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Line = exports.DividerContainer = void 0;

var _native = _interopRequireDefault(require("styled-components/native"));

var _styledUtils = require("@sloth-system/styled-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let DividerContainer = _native.default.View`
  justify-content: center;
  width: 100%;
  min-height: 1px;
  ${applySize}
`;
exports.DividerContainer = DividerContainer;
let Line = _native.default.View`
  ${applyLine}
  ${applyWeight}
`;
exports.Line = Line;

function applyWeight(props) {
  if (props.weight) {
    return `height: ${(0, _styledUtils.space)(props.weight)(props)};`;
  }

  return "";
}

function applySize(props) {
  if (props.size) {
    return `height: ${(0, _styledUtils.space)(props.size)(props)};`;
  }

  return "";
}

function applyLine(props) {
  if (props.line) {
    let colorValue = typeof props.line === "string" ? props.line : "neutrals.100";
    return `      
      width: 100%;
      height: 1px;
      background: ${(0, _styledUtils.color)(colorValue)(props)};
    `;
  }

  return "";
}